import React, { useEffect, useState } from 'react';
import './SignupForm.css';
import logo from "./img2.png"
import { Link } from 'react-router-dom';
import { postData } from '../../../services/apiServices';
import { Bars } from 'react-loader-spinner';
import toastService from '../../../services/toastService';
import { useNavigate } from 'react-router-dom';
import Loader from '../../MyComponents/Loader/Loader';


function SignupForm() {
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [lastName, setLastName] = useState('');

  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const handleSignUp = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      toastService.showError('Passwords do not match.')
      return;
    }

    const data = {
      firstname: fullName,
      lastname: lastName,
      email: email,
      password: password,
      phone: phone,
      usertype: "user",
      status: "active",
      verification_token: '123456'
    };

    try {
      setLoading(true);

      const response = await postData('/user', data);
      console.log('Signup successful:', response);
      if (response?.message === "success") {
        toastService.showSuccess("Registered Successfully");
        navigate('/');

        setEmail('');
        setFullName('');
        setLastName("")
        setPhone('');
        setPassword('');
        setConfirmPassword('');
      } else {
        toastService.showInfo(response.description)
        setLoading(false);
      }

    } catch (error) {
      console.error('Error signing up:', error);
      toastService.showError('Failed to sign up. Please try again.')
      setLoading(false);
    }
  };

  return (
    <>
    <Loader isLoading={loading}  />
          <div className='containers'>
            <header className="navbar">
              <div className="logo">
                <img src={logo} alt=" " />
              </div>
              <a href="/" className="register-link">Sign In</a>
            </header>

            <div className="signup-container">

              <div className="signin-form">
                <div className='signin-form1'>
                  <h2>Register</h2>
                  <p>Enter your details to Sign-up in to your account</p>
                  <form onSubmit={handleSignUp}>

                    <div className="input-field">
                      {/* <label htmlFor="email">Enter Email</label> */}
                      <div className="input-wrapper">
                        <i className="fas fa-user"></i>
                        <input
                          type="text"
                          id="fullName"
                          placeholder="Enter First Name"
                          className='input-txt'
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                          required
                        />
                      </div>


                      <div className="input-wrapper">
                        <i className="fas fa-user"></i>
                        <input
                          type="text"
                          id="fullName"
                          placeholder="Enter Last Name"
                          className='input-txt'
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>

                      <div className="input-wrapper">
                        <i className="fas fa-envelope"></i>
                        <input
                          type="email"
                          id="email"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      <div className="input-wrapper">
                        <i className="fas fa-phone"></i>
                        <input
                          type="tel"
                          id="phone"
                          placeholder="Phone Number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="input-field">
                      {/* <label htmlFor="password">Password</label> */}
                      <div className="input-wrapper">
                        <i className="fas fa-lock"></i>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />

                      </div>
                    </div>

                    <div className="input-field">
                      <div className="input-wrapper">
                        <i className="fas fa-lock"></i>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="confirmPassword"
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />

                      </div>
                    </div>

                    {/* <a href="/forgot-password" className="forgot-password-link">Forgot Password</a> */}
                    <button type="submit" disabled={loading}>
                      {loading ? 'Signing up...' : 'Sign Up'}
                    </button>
                  </form>
                </div>
                <p>Already have an account ? <a href="/">Sign In</a></p>
              </div>
            </div>
          </div>
        </>
     
  );
}

export default SignupForm;
